import { render, staticRenderFns } from "./CopyRatePlanListForm.vue?vue&type=template&id=25c3a218&scoped=true&"
import script from "./CopyRatePlanListForm.vue?vue&type=script&lang=js&"
export * from "./CopyRatePlanListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3a218",
  null
  
)

export default component.exports